import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IBankAccount, IBankAccountState } from "./bankaccountModel";
import {
  ActiveInactiveBankAccount,
  createBankAccount,
  deleteBankAccount,
  getAllActiveBankAccounts,
  getAllBankAccounts,
  getBankAccountByID,
  updateBankAccount,
} from "./services/bankaccount.services";

const initialState: IBankAccountState = {
  loading: false,
  formLoading: false,
  error: "",
  BankAccountID: null,
  BankAccountList: [],
  BankAccountDetail: {
    BankName: "",
    AccountNo: "",
    IFSCCode: "",
    BranchName: "",
    Address: "",
    IsActive: 1,
  },
};

const bankAccountSlice = createSlice({
  name: "bankaccount",
  initialState,
  reducers: {
    clearBankAccountDetails: (state) => {
      state.BankAccountDetail = initialState.BankAccountDetail;
    },
    setBankAccountID: (state, action) => {
      state.BankAccountID = action.payload;
    },
    clearBankAccountID: (state) => {
      state.BankAccountID = initialState.BankAccountID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllBankAccounts.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllBankAccounts.fulfilled,
      (state, action: PayloadAction<IBankAccount[]>) => {
        state.loading = false;
        state.BankAccountList = action.payload || [];
      }
    );
    builder.addCase(getAllBankAccounts.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.BankAccountList = [];
    });
    builder.addCase(createBankAccount.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createBankAccount.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createBankAccount.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateBankAccount.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateBankAccount.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateBankAccount.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteBankAccount.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteBankAccount.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteBankAccount.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getBankAccountByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getBankAccountByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.BankAccountDetail = action.payload;
    });
    builder.addCase(getBankAccountByID.rejected, (state, action) => {
      state.formLoading = false;
      state.BankAccountDetail = initialState.BankAccountDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveBankAccounts.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveBankAccounts.fulfilled,
      (state, action: PayloadAction<IBankAccount[]>) => {
        state.loading = false;
        state.BankAccountList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveBankAccounts.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.BankAccountList = [];
    });
    builder.addCase(ActiveInactiveBankAccount.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveBankAccount.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveBankAccount.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearBankAccountDetails, clearBankAccountID, setBankAccountID } =
  bankAccountSlice.actions;
export default bankAccountSlice.reducer;
